import {useCallback} from 'react';
import {produce} from 'immer';
import set from 'lodash/set';
import type {DataValue} from 'schemaDefinition/types';
import {useAppDispatch, useAppStore} from 'store/hooks';
import type {WorkV4} from '../types';
import {metadataEditWorkEdited} from '../metadataEditSlice';

export const useSetWorkEditValue = () => {
  const dispatch = useAppDispatch();
  const {getState} = useAppStore();

  return useCallback(
    (localPath: string, value: DataValue) => {
      const work = (getState().metadataEdit.metadata?.work ?? {}) as WorkV4;
      const newWork = produce(work, draft => {
        set(draft, localPath, value);
      });

      dispatch(metadataEditWorkEdited(newWork));
    },
    [dispatch, getState],
  );
};
